import { type StaticDataRouteOption, useMatches } from "@tanstack/react-router";

export const useRouteConfig = () => {
  const matches = useMatches();
  const routeConfig: StaticDataRouteOption = {};

  for (const match of matches) {
    if (match.staticData.drawer !== undefined) {
      routeConfig.drawer = match.staticData.drawer;
    }
  }

  return routeConfig;
};
